import type { Student } from "../../providers/studentsProvider";

export function canShowBankTransferInstructions(student: Student): boolean {
  return student.paymentStrategy === "purchaseOnAccount" || student.paymentStrategy === "upfrontPayment";
}
